import React, { useEffect, useState } from "react";
import { Link } from "react-scroll";
import logo from "../assets/images/logo.png";
import RegistrationFormModal from './modals/registreModal';
import LoginFormModal from './modals/loginModal';
import ForgotPasswordModal from './modals/forgotPassModal';

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const handleMenuClose = () => setIsMenuOpen(false);

    const [isLoginModalOpen, setLoginModalOpen] = useState(false);
    const [isRegisterModalOpen, setRegisterModalOpen] = useState(false);
    const [isForgotPasswordModalOpen, setForgotPasswordModalOpen] = useState(false);

    const toggleLoginModal = () => {
        setLoginModalOpen(!isLoginModalOpen);
    };

    const toggleRegisterModal = () => {
        setRegisterModalOpen(!isRegisterModalOpen);
    };

    useEffect(() => {
        if (isLoginModalOpen || isRegisterModalOpen || isForgotPasswordModalOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }

        return () => {
            document.body.style.overflow = "auto";
        };
    }, [isLoginModalOpen, isRegisterModalOpen, isForgotPasswordModalOpen]);

    return (
        <nav className="bg-primary text-white py-4 sticky top-0 z-50" style={{
            background: `linear-gradient(to left, ${"#28AE9F"}, ${"#185a9d"})`,
        }}>
            <div className="container mx-auto flex justify-between items-center px-4 text-nowrap">
                {/* Logo and Heading */}
                <div className="flex items-center gap-4">
                    <img src={logo} width={45} className="rounded" />
                    <Link className=" font-bold cursor-pointer md:text-2xl"
                        to="hero"
                        smooth={true}
                        duration={500}
                        onClick={() => {
                            handleMenuClose();
                        }}
                    >INVETIX POS</Link>
                </div>

                {/* Hamburger Menu Button */}
                <button
                    className="sm:hidden text-xl"
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                >
                    ☰
                </button>

                {/* Off-canvas Menu */}
                <div
                    className={`fixed top-0 right-0 w-52 h-full text-white p-4 transform transition-transform duration-300 ease-in-out ${isMenuOpen ? "translate-x-0" : "translate-x-full"
                        } sm:hidden`}

                    style={{
                        background: `linear-gradient(to top, ${"#28AE9F"}, ${"#185a9d"})`,
                    }}
                >
                    <button
                        className="text-xl absolute top-4 right-4"
                        onClick={handleMenuClose}
                    >
                        ×
                    </button>
                    <ul className="space-y-4 pt-6 text-start">
                        <li>
                            <Link
                                to="hero"
                                smooth={true}
                                duration={500}
                                className="hover:underline cursor-pointer"
                                onClick={() => {
                                    handleMenuClose();
                                }}
                            >
                                Home
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="features"
                                smooth={true}
                                duration={500}
                                className="hover:underline cursor-pointer"
                                onClick={() => {
                                    handleMenuClose();
                                }}
                            >
                                Features
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="contact"
                                smooth={true}
                                duration={500}
                                className="hover:underline cursor-pointer"
                                onClick={() => {
                                    handleMenuClose();
                                }}
                            >
                                Contact Us
                            </Link>
                        </li>
                        <li>
                            <label
                                onClick={() => {
                                    toggleRegisterModal();
                                    handleMenuClose(); // Close the menu after opening the modal
                                }}
                                className="hover:underline cursor-pointer"
                            >
                                Register
                            </label>
                        </li>
                        <li>
                            <label
                                onClick={() => {
                                    toggleLoginModal();
                                    handleMenuClose(); // Close the menu after opening the modal
                                }}
                                className="hover:underline cursor-pointer"
                            >
                                Login
                            </label>
                        </li>
                    </ul>
                </div>

                {/* Navigation Links for larger screens */}
                <ul className="sm:flex sm:space-x-6 space-y-4 sm:space-y-0 sm:items-center hidden">
                    <li>
                        <Link
                            to="hero"
                            smooth={true}
                            duration={500}
                            className="hover:underline cursor-pointer"
                        >
                            Home
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="features"
                            smooth={true}
                            duration={500}
                            className="hover:underline cursor-pointer"
                        >
                            Features
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="contact"
                            smooth={true}
                            duration={500}
                            className="hover:underline cursor-pointer"
                        >
                            Contact Us
                        </Link>
                    </li>
                    <li>
                        <button
                            onClick={toggleRegisterModal}
                            className="bg-blue-500 px-4 py-2 rounded hover:bg-blue-600"
                        >
                            Register
                        </button>
                    </li>
                    <li>
                        <button
                            onClick={toggleLoginModal}
                            className="bg-blue-500 px-4 py-2 rounded hover:bg-blue-600"
                        >
                            Login
                        </button>
                    </li>
                </ul>
            </div>
            <RegistrationFormModal isOpen={isRegisterModalOpen} onClose={() => setRegisterModalOpen(!isRegisterModalOpen)} toggleModal={toggleRegisterModal} />
            {isLoginModalOpen && <LoginFormModal toggleModal={toggleLoginModal} openForgotPasswordModal={() => setForgotPasswordModalOpen(true)} />}
            {isForgotPasswordModalOpen && (
                <ForgotPasswordModal
                    toggleModal={() => setForgotPasswordModalOpen(false)}
                />
            )}
        </nav>
    );
};

export default Navbar;